import React from 'react';
import { Card, Button, Space, Typography, Alert } from 'antd';
import PermissionGuard, { PermissionShow } from '../components/PermissionGuard';
import { usePermission, useModulePermission } from '../hooks/usePermission';
import { Modules } from '../constants/permissions';

const { Title, Text } = Typography;

const PermissionDemo: React.FC = () => {
  const { isAdmin, permissions } = usePermission();
  const inventoryPermissions = useModulePermission(Modules.INVENTORY);

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>權限系統展示</Title>
      
      <Alert 
        message="當前用戶權限" 
        description={
          <div>
            <p>是否為管理員：{isAdmin ? '是' : '否'}</p>
            <p>權限列表：{permissions.length > 0 ? permissions.join(', ') : '無權限'}</p>
          </div>
        }
        type="info" 
        style={{ marginBottom: 24 }}
      />

      <Space direction="vertical" style={{ width: '100%' }} size="large">
        {/* 庫存模組權限展示 */}
        <Card title="庫存模組權限">
          <Space direction="vertical" style={{ width: '100%' }}>
            <div>
              <Text>查看權限：</Text>
              <Text type={inventoryPermissions.canView ? 'success' : 'danger'}>
                {inventoryPermissions.canView ? '✅ 有權限' : '❌ 無權限'}
              </Text>
            </div>
            <div>
              <Text>新增權限：</Text>
              <Text type={inventoryPermissions.canCreate ? 'success' : 'danger'}>
                {inventoryPermissions.canCreate ? '✅ 有權限' : '❌ 無權限'}
              </Text>
            </div>
            <div>
              <Text>編輯權限：</Text>
              <Text type={inventoryPermissions.canEdit ? 'success' : 'danger'}>
                {inventoryPermissions.canEdit ? '✅ 有權限' : '❌ 無權限'}
              </Text>
            </div>
            <div>
              <Text>刪除權限：</Text>
              <Text type={inventoryPermissions.canDelete ? 'success' : 'danger'}>
                {inventoryPermissions.canDelete ? '✅ 有權限' : '❌ 無權限'}
              </Text>
            </div>
          </Space>
        </Card>

        {/* 按鈕權限控制展示 */}
        <Card title="按鈕權限控制展示">
          <Space>
            <Button type="primary">查看（總是顯示）</Button>
            
            <PermissionShow module={Modules.INVENTORY} action="add">
              <Button type="primary">新增庫存</Button>
            </PermissionShow>
            
            <PermissionShow module={Modules.INVENTORY} action="edit">
              <Button>編輯庫存</Button>
            </PermissionShow>
            
            <PermissionShow module={Modules.INVENTORY} action="delete">
              <Button danger>刪除庫存</Button>
            </PermissionShow>
          </Space>
        </Card>

        {/* 頁面權限控制展示 */}
        <Card title="頁面權限控制展示">
          <PermissionGuard 
            module={Modules.INVENTORY} 
            action="query"
            fallback={
              <Alert 
                message="無權限" 
                description="您沒有查看庫存的權限" 
                type="error" 
              />
            }
          >
            <Alert 
              message="有權限" 
              description="您可以查看庫存資料" 
              type="success" 
            />
          </PermissionGuard>
        </Card>
      </Space>
    </div>
  );
};

export default PermissionDemo;